<template>
  <div class="pb-2 bg-white nav-mobile-render">
    <ul>
      <li v-for="(item, index) in menuItems" :key="index" class="flex flex-col items-center justify-between border-b-gray-ultralight border-b-1">
        <div class="flex items-center justify-between w-full nav-mobile-render-linkrow">
          <button class="flex items-stretch justify-between w-full pl-4 text-xl" @click="toggleMenuItem($event, anyChildrenActive(item.nodes ?? []))" :data-testid="`mobileMenuNavTreeToggleButtonLvl1-${index}`">
            <span class="flex items-center py-2 text-xl" :class="item.isSelected ? 'page-active' : ''" :data-testid="`mobileMenuNavTreeItemLvl1-${index}`">{{ item.heading }}</span>
            <div class="px-3 py-3 nav-mobile-render-wrap-icons">
              <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="none" viewBox="0 0 36 36" :class="anyChildrenActive(item.nodes ?? []) ? 'hidden' : ''" :data-testid="`mobileMenuNavTreeToggleButtonPlusIconLvl1-${index}`">
                <rect width="36" height="36" fill="transparent" rx="18" />
                <path fill="#2C2827" fill-rule="evenodd" d="M16.847 16.851V9.028h2.306V26.97h-2.306v-7.813l-7.818-.003v-2.303h7.818Zm10.124 2.303h-5.975v-2.306h5.975v2.306Z" clip-rule="evenodd" />
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="none" viewBox="0 0 36 36" :class="anyChildrenActive(item.nodes ?? []) ? '' : 'hidden'" :data-testid="`mobileMenuNavTreeToggleButtonMinusIconLvl1-${index}`">
                <rect width="36" height="36" fill="transparent" rx="18" />
                <path fill="#2C2827" d="M25.973 19.025H10.025v-2.05h15.948v2.05Z" />
              </svg>
            </div>
          </button>
        </div>
        <ul class="level-wrapper">
          <li v-for="(itemlvl2, index2) in item.nodes" :key="index2">
            <div class="flex items-stretch justify-between w-full border-white border-t-1 nav-mobile-render-linkrow">
              <a
                :href="itemlvl2.url"
                :target="itemlvl2.target === '' ? '_self' : itemlvl2.target"
                class="pl-[26px] text-lg flex items-center w-full"
                :class="itemlvl2.isSelected ? 'page-active' : ''"
                :data-testid="`mobileMenuNavTreeItemLinkLvl2-${index}-${index2}`"
                >{{ itemlvl2.text }}</a
              >
              <button
                class="px-3 py-2 border-white border-l-1 lvl2Button"
                @click="
                  toggleMenuItem(
                    $event,
                    itemlvl2.items.find((x) => x.isSelected === true)
                  )
                "
                :data-testid="`mobileMenuNavTreeToggleButtonLvl2-${index}-${index2}`">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="36"
                  height="36"
                  fill="none"
                  viewBox="0 0 36 36"
                  :class="itemlvl2.items.find((x) => x.isSelected === true) ? 'hidden' : ''"
                  :data-testid="`mobileMenuNavTreeToggleButtonPlusIconLvl2-${index}-${index2}`">
                  <rect width="36" height="36" fill="#E5E3E1" rx="18" />
                  <path fill="#2C2827" fill-rule="evenodd" d="M16.847 16.851V9.028h2.306V26.97h-2.306v-7.813l-7.818-.003v-2.303h7.818Zm10.124 2.303h-5.975v-2.306h5.975v2.306Z" clip-rule="evenodd" />
                </svg>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="36"
                  height="36"
                  fill="none"
                  viewBox="0 0 36 36"
                  :class="itemlvl2.items.find((x) => x.isSelected === true) ? '' : 'hidden'"
                  :data-testid="`mobileMenuNavTreeToggleButtonMinusIconLvl2-${index}-${index2}`">
                  <rect width="36" height="36" fill="#E5E3E1" rx="18" />
                  <path fill="#2C2827" d="M25.973 19.025H10.025v-2.05h15.948v2.05Z" />
                </svg>
              </button>
            </div>
            <ul class="py-2 level-wrapper">
              <li v-for="(itemlvl3, index3) in itemlvl2.items" :key="index3" class="">
                <a
                  :href="itemlvl3.url"
                  :target="itemlvl3.target === '' ? '_self' : itemlvl3.target"
                  class="text-lg pl-[40px] py-1.5 inline-block w-full"
                  :class="itemlvl3.isSelected ? 'page-active' : ''"
                  :data-testid="`mobileMenuNavTreeItemLinkLvl3-${index}-${index2}-${index3}`"
                  >{{ itemlvl3.text }}</a
                >
              </li>
            </ul>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'EllevioWebMobileNavTree',
  components: {},
  props: {
    menuItems: {
      type: Array,
      default: () => []
    },
    menuOpen: {
      type: Boolean,
      default: false
    },
    indentWidth: {
      type: Number,
      default: 15
    }
  },
  watch: {
    menuOpen(val) {
      if (val === true) {
        this.$nextTick(() => {
          const children = document.querySelectorAll('.nav-mobile-render-linkrow + ul')
          for (let i = 0; i < children.length; i++) {
            if (children[i].checkVisibility()) {
              children[i].previousSibling.querySelector('.nav-mobile-render-wrap-icons')?.classList.add('bgGray')
              children[i].parentNode.querySelector('.lvl2Button')?.classList.add('bgGray')
            }
          }
        })
      }
    }
  },
  methods: {
    anyChildrenActive(items) {
      return items.find((child) => child.isSelected === true) || items.find((child) => child.items.find((grandChild) => grandChild.isSelected === true))
    },
    toggleMenuItem($event, activeItem) {
      const el = $event.target.closest('.nav-mobile-render-linkrow')
      const plusSvg = el.querySelector('svg:first-of-type')
      const minusSvg = el.querySelector('svg:last-of-type')
      const lvl1Wrapper = el.querySelector('.nav-mobile-render-wrap-icons')
      const lvl2Button = el.querySelector('.lvl2Button')
      const nextEl = el.nextElementSibling
      if (nextEl) {
        if (nextEl.classList.contains('!block')) {
          nextEl.classList.remove('!block')
          nextEl.classList.add('!hidden')
        } else if (nextEl.classList.contains('!hidden')) {
          nextEl.classList.remove('!hidden')
          nextEl.classList.add('!block')
        } else {
          if (activeItem) {
            nextEl.classList.remove('!block')
            nextEl.classList.add('!hidden')
          } else {
            nextEl.classList.remove('!hidden')
            nextEl.classList.add('!block')
          }
        }
      }
      if (plusSvg) {
        plusSvg.classList.toggle('hidden')
      }
      if (minusSvg) {
        minusSvg.classList.toggle('hidden')
      }
      if (lvl1Wrapper) {
        lvl1Wrapper.classList.toggle('bgGray')
      }
      if (lvl2Button) {
        lvl2Button.classList.toggle('bgGray')
      }
    }
  }
}
</script>
<style scoped>
/*
.nav-mobile-render .nav-mobile-render-linkrow + ul {
  display: none;
}
*/

.nav-mobile-render ul,
.nav-mobile-render li {
  width: 100%;
}

.nav-mobile-render ul ul {
  background-color: #f8f8f8; /* #f2f1f0;*/
}
.nav-mobile-render ul ul ul {
  background-color: #f1f1f1; /* #e5e3e1; */
}
.nav-mobile-render-wrap-icons.bgGray {
  background-color: #f8f8f8; /* #f2f1f0; */
}
.lvl2Button.bgGray {
  background-color: #f1f1f1; /* #e5e3e1; */
}
.level-wrapper {
  display: none;
}
.level-wrapper:has(.page-active) {
  display: block;
}
.page-active {
  @apply font-futuraEfDemiBold;
}
</style>
